<template>
    <div id="card" v-if="product">
        <p class="title" v-if="product.title">{{product.title}}</p>
        <img v-if="product.img" :src="product.img">
        <div class="list" v-if="product.description" v-html="product.description">
        </div>
        <p class="price" v-if="product.price">Prezzo iva esclusa: <span>{{product.price}}€</span></p>
    </div>
</template>

<script>
    export default {
      name: "Card",
      props: {
        product: {
          type: Object
        }
      }
    }
</script>

<style lang="less">
    @import "../assets/variabili.less";
    @import "../assets/font.less";

    #card{
        height: 525px;
        width: 100%;
        margin-right: 5%;
        box-shadow: 0 0 20px @gray;
        border-radius: 20px;
        position: relative;
        &:last-child{
            margin-right: 0px;
        }
        .title{
            padding-top: 10px;
            .set-font(@family: "druk-bold", @size: 16px, @color: @firstColor)
        }
        img{
            width: 50%;
            margin: auto;
        }
        .list{
            ul{
                padding: 0 5px 0 25px;
                li{
                    list-style: circle;
                    text-align: left;
                    .set-font(@family: 'sama-medium', @size: 14px, @color: @textColor);
                }
            }
        }
        .price{
            text-align: right;
            padding-right: 20px;
            bottom: 0px;
            right: 0px;
            position: absolute;
            .set-font(@size: 16px, @color: @firstColor);
            span{
                .set-font(@family: 'sama-medium', @size: 20px, @color: @firstColor)
            }
        }

    }
    @media (max-width: 768px) {
        #card{
            width: 90%;
        }
    }
</style>
